/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Geo.css';
import Ranktable from './../../components/Ranktable'
import Article from './../../components/Article'
import Hotpush from './../../components/Hotpush'
import moment from 'moment'

const list = [
  {
    key: 'A',
    value: [
      {
        geo:'安徽',
        color:'init'
      },{
        geo:'澳门',
        color:'noInt'
      }
    ]
    // color:['#333','#ccc']
  },{
    key:'B',
    value:[
      {
        geo:'北京',
        color:'init'
      }
    ]
  },{
    key:'C',
    value:[
      {
        geo:'重庆',
        color:'init'
      }
    ]
  },{
    key:'F',
    value:[
      {
        geo:'福建',
        color:'init'
      }
    ]
  },{
    key:'G',
    value:[
      {
        geo:'广西',
        color:'noInt'
      },{
        geo:'广东',
        color:'init'
      },{
        geo:'贵州',
        color:'init'
      },{
        geo:'甘肃',
        color:'init'
      }
    ]
  },{
    key:'H',
    value:[
      {
        geo:'黑龙江',
        color:'init'
      },{
        geo:'河北',
        color:'init'
      },{
        geo:'河南',
        color:'init'
      },{
        geo:'湖北',
        color:'init'
      },{
        geo:'湖南',
        color:'noInt'
      },{
        geo:'海南',
        color:'init'
      }
    ]
  },{
    key:'J',
    value:[
      {
        geo:'吉林',
        color:'init'
      },{
        geo:'江苏',
        color:'init'
      },{
        geo:'江西',
        color:'noInt'
      }
    ]
  },{
    key:'L',
    value:[
      {
        geo:'辽宁',
        color:'init'
      }
    ]
  }
]


const list1 = [
  {
    key: 'A',
    value: [
      {
        geo:'安徽',
        color:'init'
      },{
        geo:'澳门',
        color:'noInt'
      }
    ]
    // color:['#333','#ccc']
  },{
    key:'B',
    value:[
      {
        geo:'北京',
        color:'init'
      }
    ]
  },{
    key:'C',
    value:[
      {
        geo:'重庆',
        color:'init'
      }
    ]
  },{
    key:'F',
    value:[
      {
        geo:'福建',
        color:'init'
      }
    ]
  },{
    key:'G',
    value:[
      {
        geo:'广西',
        color:'noInt'
      },{
        geo:'广东',
        color:'init'
      },{
        geo:'贵州',
        color:'init'
      },{
        geo:'甘肃',
        color:'init'
      }
    ]
  },{
    key:'H',
    value:[
      {
        geo:'黑龙江',
        color:'init'
      },{
        geo:'河北',
        color:'init'
      },{
        geo:'河南',
        color:'init'
      },{
        geo:'湖北',
        color:'init'
      },{
        geo:'湖南',
        color:'noInt'
      },{
        geo:'海南',
        color:'init'
      }
    ]
  },{
    key:'J',
    value:[
      {
        geo:'吉林',
        color:'init'
      },{
        geo:'江苏',
        color:'init'
      },{
        geo:'江西',
        color:'noInt'
      }
    ]
  },{
    key:'L',
    value:[
      {
        geo:'辽宁',
        color:'init'
      }
    ]
  },{
    key:'N',
    value:[
      {
        geo:'内蒙古',
        color:'init'
      },{
        geo:'宁夏',
        color:'noInt'
      }
    ]
  },{
    key:'Q',
    value:[
      {
        geo:'青海',
        color:'noInt'
      }
    ]
  },{
    key:'S',
    value:[
      {
        geo:'上海',
        color:'init'
      },{
        geo:'陕西',
        color:'init'
      },{
        geo:'四川',
        color:'init'
      },{
        geo:'山东',
        color:'init'
      },{
        geo:'山西',
        color:'noInt'
      }
    ]
  },{
    key:'T',
    value:[
      {
        geo:'天津',
        color:'noInt'
      },{
        geo:'台湾',
        color:'init'
      }
    ]
  },{
    key:'X',
    value:[
      {
        geo:'新疆',
        color:'noInt'
      },{
        geo:'西藏',
        color:'init'
      },{
        geo:'香港',
        color:'init'
      }
    ]
  },{
    key:'Y',
    value:[
      {
        geo:'云南',
        color:'noInt'
      }
    ]
  },{
    key:'Z',
    value:[
      {
        geo:'浙江',
        color:'init'
      }
    ]
  }
]


const list2 = [
  {
    key: 'A',
    value: ['澳大利亚']
  }, {
    key: 'D',
    value: ['德国']
  }, {
    key: 'F',
    value: ['法国']
  }, {
    key: 'H',
    value: ['韩国', '荷兰']
  }, {
    key: 'M', 
    value: ['美国']
  }, {
    key: 'R',
    value: ['日本', '瑞典']
  }, {
    key: 'X',
    value: ['西班牙', '新加坡']
  }, {
    key: 'Y',
    value: ['意大利', '英国']
  }
]

// console.log(listTxt)
// listTxt.forEach(alert)

class Geo extends React.Component {

  constructor() {
    super()
    this.state = {
      isShow: true,
      tit: '北京',
      time:null
    }
    this.getArtTime=this.getArtTime.bind(this)
  }
  componentWillMount() {
    // console.log(moment().format('a'))
    if(this.state.time==null){
			if(moment().format('a')=='pm'){
        this.setState({time:`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`})
      }else{
        this.setState({time:`${moment().subtract(8,'days').format('YYYY-MM-DD')},${moment().subtract(2,'days').format('YYYY-MM-DD')}`})
      }
		}
  }
  getArtTime=(ss)=>{
    this.setState({time:ss})
  }

  showMoreProvince() {

    let geoMapList =this.state.isShow?list:list1

    return(
      <span>
      {geoMapList.map((item,index) =>
        <span className={s.brSpan} key={index}>
          <em>{item.key}</em>
          {item.value.map((ss, index) =>
            <span key={index} className={this.state.tit==ss.geo?s.ac:s[ss.color]}  
            onClick={() => {
              if(ss.color!='noInt'){
                this.setState({ 
                  tit: ss.geo,
                })
              }
            }}>{ss.geo}</span>
          )}
        </span>
      )}
    </span>
    )



    // switch (this.state.isShow) {
    //   case (true):
    //     return (
    //       <span>
    //         {list.map((item,index) =>
    //           <span className={s.brSpan} key={index}>
    //             <em>{item.key}</em>
    //             {item.value.map((ss, index) =>
    //               <span key={index} className={this.state.tit==ss?s.ac:s[ss.color]}  onClick={() => {

    //                 if(ss.color!='noInt'){

    //                   this.setState({ 
    //                     tit: ss,
    //                   })
    //                 }
                     
    //               }}>{ss.geo}</span>
    //             )}
    //           </span>
    //         )}
    //       </span>
    //     )
    //     break
    //   case (false):
    //     return (
    //       <span>
    //         {list1.map((item,index) =>
    //           <span className={s.brSpan} key={index}>
    //             <em>{item.key}</em>
    //             {item.value.map((ss, index) =>
    //               <span key={index} className={this.state.tit==ss?s.ac:null}  onClick={() => {
    //                 this.setState({ tit: ss })
    //               }}>{ss}</span>
    //             )}
    //           </span>
    //         )}
    //       </span>
    //     )
    //     break
    // }
  }

  render() {
    // console.log(list.forEach())
    // this.showMoreProvince()
    const {tit}=this.state
    // console.log(moment().format('a'),this.state.time,moment().format('a')=='pm')
    
    return (
      <div className={s.root}>
        {/* <div className={s.geo}>
          <div className={s.province}>
            <span className={s.bold}>国内：</span>


            {this.showMoreProvince()}
            <div className={this.state.isShow?s.geoMoreFalse:s.geoMore} onClick={() => { this.setState({ isShow: !this.state.isShow }) }}></div>
          </div>
          <div className={s.country}>
            <span className={s.bold}>
              国外：
            </span>
            {list2.map((item, index) =>
              <span key={index}>
                <em>{item.key}</em>
                {item.value.map((item,index) =>
                  <span key={index} className={this.state.tit==item?s.ac:null}  onClick={() => {
                    this.setState({ tit: item })
                  }}>{item}</span>
                )}
              </span>
            )}
            <div className={s.geoMore}></div>
          </div>
        </div> */}
        <Ranktable rank='geo' tit={this.props.childrenData} getArtTime={this.getArtTime} />
        {/* <Article time={this.state.time} region={tit}/> */}
        {/* <Hotpush /> */}
      </div>
    );
  }
}

export default withStyles(s)(Geo);



// WEBPACK FOOTER //
// src/routes/geo/Geo.js